import React from 'react';
import style from './style';

const FicheContextHeader = ({children}) => {
  const {classes} = style();
  return <div className={classes.root}>
    {children}
  </div>
}

export default FicheContextHeader;